module.exports = __webpack_public_path__ + "static/thumbnail-nfi-graph-f46a8f2e9156d0070c214dca4bb3453d.png";